import {
  Object3D,
  PlaneGeometry,
  Mesh,
  TextureLoader,
  Color,
  RawShaderMaterial,
} from 'three'
// import { gsap } from 'gsap'

import vertexShader from './vert.glsl'
import fragmentShader from './frag.glsl'
import { component } from '../../bidello'
import camera from '../camera'
// import scene from '../scene'
// import renderer from '../renderer'

class Smoke extends component(Object3D) {
  constructor() {
    super()
    // this.visible = false
  }

  async onLoadEnd() {
    this.material = new RawShaderMaterial({
      transparent: true,
      vertexShader,
      fragmentShader,
      uniforms: {
        uTime: { value: 0 },
        uColor: { value: new Color(0x011c22) },
        uNoiseFrequency: { value: 1 },
        uNoiseAmplitude: { value: 0.02 },
        uNoiseSpeed: { value: 0.00008 },
        uFade: { value: 1 }
      }
    })

    const geometry = new PlaneGeometry(1, 1)
    this.mesh = new Mesh(geometry, this.material)

    this.mesh.position.z = -8
    this.mesh.frustumCulled = false

    this.setScale()

    // renderer.compile(scene, camera)

    this.add(this.mesh)
    this.mesh.visible = true

    this.addListeners()
  }

  addListeners() {
    window.addEventListener('resize', this.setScale.bind(this))
  }

  setScale() {
    const isMobile = window.innerWidth < 768
    const size = camera.calculateUnitSize(-8 -10)

    const scale = isMobile ? size.height : size.width
    this.mesh.scale.set(scale, scale)
    this.updateMatrix()
    this.mesh.updateMatrix()
  }

  onRaf({ now }) {
    if (this.material && this.visible) {
      this.material.uniforms.uTime.value = now
    }
  }
}

export default new Smoke()